<template>
  <div class="application-list-item">
    <!--标题-->
    <div class="title">
      <span>
        <van-icon name="home" size="24px" class-prefix="iconfont" />
        {{ xtInstanceInfo.applicateReason }}
      </span>
    </div>
    <!--详情-->
    <van-cell-group :border="false" class="detail">
      <van-cell title="登记事项" :value="xtInstanceInfo.dJSXName" :border="false">
        <van-icon
          slot="icon"
          name="product"
          size="20px"
          class-prefix="iconfont"
          class="van-cell__left-icon"
        />
      </van-cell>
      <van-cell title="业务编号" :value="xtInstanceInfo.iId" :border="false">
        <van-icon
          slot="icon"
          name="order"
          size="20px"
          class-prefix="iconfont"
          class="van-cell__left-icon"
        />
      </van-cell>
      <van-cell title="登记信息" :border="false">
        <van-icon
          slot="icon"
          name="ipad"
          size="20px"
          class-prefix="iconfont"
          class="van-cell__left-icon"
        />
        <span slot="label" class="application-info">
          <div class="application-info-cell">
            <span class="application-info-cell__title">权利人</span>
            <span class="application-info-cell__value">{{ xtInstanceInfo.contact }}</span>
          </div>
          <div class="application-info-cell">
            <span class="application-info-cell__title">收件日期</span>
            <span class="application-info-cell__value">{{ xtInstanceInfo.sJRQ | dateTime }}</span>
          </div>
          <div class="application-info-cell">
            <span class="application-info-cell__title">申请备注</span>
            <span class="application-info-cell__value">{{ xtInstanceInfo.bZ || '无' }}</span>
          </div>
        </span>
      </van-cell>
    </van-cell-group>
    <!--按钮-->
    <div class="buttons">
      <van-button
        type="default"
        size="small"
        round
        :to="{name:'XtInstanceProcess',params:{ iId:xtInstanceInfo.iId }}"
      >
        办理过程
      </van-button>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/utils'
export default {
  filters: {
    dateTime: function(dateString) {
      return formatDate(new Date(dateString), 'yyyy-MM-dd')
    }
  },
  props: {
    xtInstanceInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {}
}
</script>

<style scoped lang="scss">
.application-list-item {
  margin: 10px 10px 0px 10px;
  padding: 10px;
  font-size: 15px;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 2px 3px #bcbcbc;
  .title {
    color: #333;
    widows: 100%;
    line-height: 24px;
    font-weight: 700;
    .iconfont {
      vertical-align: -3px;
    }
    .van-tag {
      float: right;
    }
  }
  .detail {
    .application-info {
      display: block;
      padding: 10px;
      background-color: #f7f7f7;
      border-radius: 4px;
      .application-info-cell {
        height: 24px;
        line-height: 24px;
        .application-info-cell__title {
          color: #333;
        }
        .application-info-cell__value {
          float: right;
        }
      }
    }
  }
  .buttons {
    text-align: right;
    .van-button {
      margin-left: 10px;
    }
  }
}
</style>
